module.exports = __webpack_public_path__ + "img/m-banner-vbrohihj-en-US.de825e52.jpg";